import { Box, Typography } from "@mui/material";
import Modal from "components/Modal";

import CustomIcon from "components/CustomIcon";
import { CardMessage } from "components/Message";
import icons from "enums/icons";
import { FormattedMessage, useIntl } from "react-intl";

const ArchiveUserConfirmation = ({
    open,
    userName,
    closeConfirmation,
    handleArchiveUser,
}: {
    open: boolean;
    userName: string | null;
    closeConfirmation: (reason: "cancel" | "confirm") => void;
    handleArchiveUser: () => void;
}) => {
    const intl = useIntl();

    return (
        <Modal open={open}>
            <CardMessage
                hideHeaderBg
                closeButtonAction={() => closeConfirmation("cancel")}
                sx={{ maxWidth: "612px !important" }}
                title={
                    <Box display="flex" alignItems="center">
                        <CustomIcon
                            icon={icons.circledExclamationSign}
                            sx={{ fontSize: 18, color: "primary.dark", mr: 0.8 }}
                        />
                        <Typography sx={{ fontSize: 20, fontWeight: 600, color: "neutrals.dark" }}>
                            {intl.formatMessage({ id: "userManagement.archiveUser.modal.title" })}
                        </Typography>
                    </Box>
                }
                content={
                    <>
                        <Typography variant="subtitle1" mb={2}>
                            <FormattedMessage
                                id="userManagement.archiveUser.modal.content1"
                                values={{ userName: userName }}
                            />
                        </Typography>
                        <Typography variant="subtitle1">
                            <FormattedMessage id="userManagement.archiveUser.modal.content2" />
                        </Typography>
                    </>
                }
                actions={[
                    {
                        label: <FormattedMessage id="hubManagement.client.removeUserModal.cancelLabel" />,
                        buttonProps: { variant: "outlined" },
                        onClickAction: () => closeConfirmation("cancel"),
                    },
                    {
                        label: <FormattedMessage id="hubManagement.client.removeUserModal.confirmLabel" />,
                        endIcon: <CustomIcon icon={icons.chevronRightThin} sx={{ fontSize: 16, color: "white" }} />,
                        onClickAction: () => handleArchiveUser(),
                    },
                ]}
            />
        </Modal>
    );
};

export default ArchiveUserConfirmation;
